import { CircleAlert, RefreshCw } from "lucide-react";
import type { ReactElement } from "react";

import { cn } from "@/lib/utils";
import { signal } from "@/motion/signals";

export function WorkspaceFailureCard({
  explanation,
  hasPreview,
  retryDisabled,
  onRetry,
  enter = false,
}: {
  explanation?: string;
  hasPreview: boolean;
  retryDisabled: boolean;
  onRetry: () => void;
  enter?: boolean;
}): ReactElement {
  return (
    <div
      role="alert"
      className={cn(
        "overflow-hidden rounded-xl border border-[#e4d8c7] bg-[#fffaf2] px-3 py-3 shadow-[0_5px_18px_rgba(80,58,31,0.05)]",
        enter && signal.undo,
      )}
    >
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg bg-[#f2e6d5] text-[#875c2d]">
          <CircleAlert className="size-4" aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="font-semibold leading-5 text-[#3f3529]">
            That update didn’t finish
          </p>
          <p className="mt-0.5 whitespace-pre-wrap text-xs leading-5 text-[#746757]">
            {explanation ?? "Try again or describe the change another way."}
          </p>
          {hasPreview ? (
            <p className="mt-1 text-xs leading-5 text-[#746757]">
              Your current preview is unchanged.
            </p>
          ) : null}
          <button
            type="button"
            disabled={retryDisabled}
            onClick={onRetry}
            className="mt-2 inline-flex items-center gap-1.5 rounded-lg border border-[#ddcfbc] bg-white px-2.5 py-1.5 text-xs font-semibold text-[#75502a] shadow-sm transition-colors hover:bg-[#fffdf9] disabled:cursor-not-allowed disabled:opacity-50"
          >
            <RefreshCw className="size-3" aria-hidden="true" />
            Try again
          </button>
        </div>
      </div>
    </div>
  );
}
